import { LayoutTemplate } from "../LayoutTemplate";
import * as S from "./styles";
import { SubTitle } from "../../Atoms/SubTitle";
import { LineChart } from "@mui/x-charts";
import { ILineChartprops, useDataTendencia } from "./useData";
import { GraphColors } from "../../../utils/graphCorlors";
import { ContinuousCalendar } from "../../Molecules/ContinuousCalendar/ContinuousCalendar";
import { KeyMetrics } from "../../Atoms/KeyMetrics";

interface ILegend {
  title: string;
  color: string;
}
const TrendChart = ({
  title,
  chartData,
  legends,
}: {
  title: string;
  chartData: ILineChartprops;
  legends?: ILegend[];
}) => (
  <div>
    <SubTitle>{title}</SubTitle>
    <S.Card>
      <LineChart
        margin={{ bottom: 70 }}
        height={300}
        width={560}
        xAxis={[{ scaleType: "band", data: chartData?.xAxis || [] }]}
        series={chartData?.series || []}
        slotProps={{
          legend: { hidden: true },
        }}
      />

      <S.WrapperLegends>
        {legends?.map((e, i) => (
          <S.Legend key={i}>
            <S.BoxColor color={e?.color} />
            <S.TextLegend>{e?.title}</S.TextLegend>
          </S.Legend>
        ))}
      </S.WrapperLegends>
    </S.Card>
  </div>
);

export const TendenciesTemplate = () => {
  const {
    data,
    tendenciasGeral,
    tendenciasTipoServico,
    tendenciasUnidade,
    tendenciasAtendimento,
  } = useDataTendencia();

  return (
    <LayoutTemplate title="Dashboard de Tendência">
      <div className="flex gap-4 items-center mb-9">
        <KeyMetrics title="Meta" value={data?.meta || 0} />
        <KeyMetrics title="Produção" value={data?.producao || 0} />
        <KeyMetrics title="Revistorias" value={data?.revistorias || 0} />
        <KeyMetrics title="Líquido" value={data?.producaoLiquido || 0} />
        <KeyMetrics title="Necessidade/Dia" value={data?.necessidadeDia || 0} />
        <KeyMetrics title="Projeção" value={data?.projecao || 0} />
        <KeyMetrics
          title="Tendência"
          value={`${data?.tendencia || 0} %`}
          isActive
        />
      </div>

      <div className="grid gap-4 grid-cols-1 lg:[grid-template-columns:600px_600px]">
        <TrendChart
          title="Tendência Geral"
          chartData={tendenciasGeral}
          legends={[
            {
              title: "Geral",
              color: GraphColors[data?.empresa],
            },
          ]}
        />
        <TrendChart
          title="Tendência por Tipo de Serviço"
          chartData={tendenciasTipoServico}
          legends={tendenciasTipoServico?.series?.map((e) => ({
            title: e.label,
            color: e.color,
          }))}
        />
        <TrendChart
          title="Tendência por Tipo de Atendimento"
          chartData={tendenciasAtendimento}
          legends={tendenciasAtendimento?.series?.map((e) => ({
            title: e.label,
            color: e.color,
          }))}
        />
        <TrendChart
          title="Tendência por Unidade"
          chartData={tendenciasUnidade}
          legends={tendenciasUnidade?.series?.map((e) => ({
            title: e.label,
            color: e.color,
          }))}
        />
      </div>

      <div className="mb-9 ">
        <S.TableTitle>HeatMap do mês</S.TableTitle>

        <div className="flex gap-10 items-center w-fit mx-auto">
          <ContinuousCalendar data={data?.producaoDiaria} />

          <img src="/assets/svg/temp.svg" alt="temperatura" />
        </div>
      </div>

      <S.TableTitle>Desempenho em Relação a Meta</S.TableTitle>

      <S.Table>
        <S.TableHead>
          <tr>
            <td>Unidade</td>
            <td>Meta</td>
            <td>Realizado</td>
            <td>Média/dia</td>
            <td>Necessidade/dia</td>
            <td>Projeção</td>
          </tr>
        </S.TableHead>
        <S.TableBody>
          {data?.unidades?.length > 0 &&
            data?.unidades?.map((empresa) => (
              <tr key={Math.random()}>
                <td>{`${empresa?.cidade} - ${empresa.uf}`}</td>
                <td>{`${empresa?.meta || 0}`}</td>
                <td>{`${empresa?.qtdTotal || 0}`}</td>
                <td>{empresa?.qtdMedia}</td>
                <td>{empresa?.qtdMediaNecessaria}</td>
                <td>{`${empresa?.qtdMediaProjecao || 0}`}</td>
              </tr>
            ))}
        </S.TableBody>
      </S.Table>
    </LayoutTemplate>
  );
};
